/**
 * Translates the legacy PageTemplate header props (`title`, `headerControls`)
 * into the new PageHeader's props, resolving every non-plain-string `title`
 * shape found across real call sites.
 *
 * `icon`/`iconImg` are accepted but always dropped — the new PageHeader has
 * no icon slot by design (icons now live in the sidebar nav, not the
 * content header); `MailchimpInstructionsPage` is the only `iconImg` user
 * and its plain "Mailchimp" string title is sufficient on its own.
 *
 * `className` of `page-wrapper-widget`/`page-wrapper-with-white-bg` marks a
 * builder-type page (widget preview canvas + settings panel) — these need
 * a `compact` PageHeader and a full-height flex body instead of the normal
 * padded scrolling one, since the canvas/panel split manages its own
 * internal scrolling rather than scrolling with the page. Any other
 * `className` is dropped (a visual-QA watch item, not a required port —
 * those classes exist to interact with the old shell's fixed-position CSS,
 * which has no equivalent surface in the new shell's normal-flow layout).
 *
 * @param {ReactNode} title
 * @param {ReactNode=} headerControls
 * @param {string=} className
 * @returns {{title: ReactNode, actions: ReactNode, extraHeaderBlock: ReactNode|null, compact: boolean}}
 */
import React from "react";
// import QuotaPageHeader from "./QuotaPageHeader";
import WidgetName from "../../component/WidgetSettings/WidgetName";

const BUILDER_CLASSNAMES = [
  "page-wrapper-widget",
  "page-wrapper-with-white-bg",
];

export function mapLegacyHeaderProps(title, headerControls, className) {
  // headerControls needs no branching at all: PageHeader's
  // `{actions && <div>...}` already renders bare elements, arrays, or any
  // truthy node correctly, and already no-ops on the one real empty-string
  // case (Reports/EventEngagement) via plain JS falsiness.
  const actions = headerControls;
  const compact = BUILDER_CLASSNAMES.includes(className);

  // if (React.isValidElement(title) && title.type === QuotaPageHeader) {
  //   return { title: title.props.title, actions, extraHeaderBlock: title, compact };
  // }

  if (React.isValidElement(title) && title.type === WidgetName) {
    return {
      title: title.props.widgetName,
      actions,
      extraHeaderBlock: title,
      compact,
    };
  }

  // Majority case: plain string / template-string titles, or a loading
  // placeholder string in place of a WidgetName/QuotaPageHeader element.
  return { title, actions, extraHeaderBlock: null, compact };
}
